module.exports = __webpack_public_path__ + "media/images/logo_web-18355ab94d84b0d8d53fbdea3df33282.png";